import { colors } from '../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../utils/math/ApplyRounding';
import { Body3 } from '../../../../../../atomic/text/Text';

type Props = {
  tradePlanId: string;
};

export const PositionComponent = ({ tradePlanId }: Props) => {
  const { tradePlanStore } = useWebsocketStore();
  const positionId = tradePlanStore.tradePlans[tradePlanId].positionId;
  const position = tradePlanStore.positions.tradeUnafraid[positionId] ?? null;
  const size = position.quantity ?? 0;
  const fill = ApplyRounding(position.avg_fill_price, 2) ?? 0;
  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Size:{' '}
        </Body3>
        <Body3 color={colors.lightGrey}> {size}</Body3>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr' }}>
        <Body3 color={colors.lightGrey} fontWeight={700}>
          Fill:{' '}
        </Body3>
        <Body3 color={colors.lightGrey}> ${fill}</Body3>
      </div>
    </div>
  );
};
